/**
 * Application Router
 * Настройка маршрутизации приложения
 */

import { FC, Suspense, lazy } from 'react';

import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Toaster } from 'sonner';

import { ErrorBoundary } from '../../components/ErrorBoundary';
import { TradingLayout } from '../../layouts/TradingLayout';

// Lazy-loaded pages для code splitting
const TradingDashboard = lazy(() => import('../../pages/TradingDashboard').then(module => ({ default: module.TradingDashboard })));
const Agents = lazy(() => import('../../pages/Agents'));
const Statistics = lazy(() => import('../../pages/Statistics'));
const Strategies = lazy(() => import('../../pages/Strategies').then(module => ({ default: module.Strategies })));
const Backtest = lazy(() => import('../../pages/Backtest'));
const Notifications = lazy(() => import('../../pages/Notifications'));
const Settings = lazy(() => import('../../pages/Settings'));

// Loading component
const PageLoader = () => {
  const { t } = useTranslation('layout');

  return (
    <div
      className="flex items-center justify-center h-64"
      role="status"
      aria-label={t('pageLoader.label')}
    >
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    </div>
  );
};

export const AppRouter: FC = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<TradingLayout />}>
            <Route index element={<TradingDashboard />} />
            <Route path="trading" element={<TradingDashboard />} />
            <Route path="agents" element={<Agents />} />
            <Route path="statistics" element={<Statistics />} />
            <Route path="strategies" element={<Strategies />} />
            <Route path="backtest" element={<Backtest />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </Suspense>
      <Toaster />
    </ErrorBoundary>
  );
};
